<template>
  <el-dialog :visible.sync="visible" width="40%" :before-close="handleClose" @closed="resetForm">
    <div slot="title" class="dialog-title">
      <h2 style="margin-bottom: 2px">{{ operationTypeText }}到</h2>
      <span class="title_tips">点击选择想要{{ operationTypeText }}到的目标位置，支持输入题目关键字模糊搜索</span>
    </div>
    <div class="flex-row align-center">
      <span>{{ operationTypeText }}到</span>
      <el-cascader
        class="ml-10 mr-10"
        v-model="symbolFormItemId"
        :options="cascaderOptions"
        :filterable="true"
        :show-all-levels="false"
        :props="{
          expandTrigger: 'hover'
        }"
      >
      </el-cascader>

      <el-select v-model="moveType" style="width: 80px">
        <el-option v-for="item in moveTypeMap" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
    </div>

    <div class="flex-row align-center pt-10" v-if="operationType === 'copy'">
      <span>复制次数</span>
      <el-input
        style="width: 100px; margin-left: 10px"
        v-model="frequency"
        placeholder="＜10次"
        @input="validateInput"
      />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="batchEditSelectItems">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { copyOutlineProject, saveOutlineMove } from '@/api/project/form'

/**
 * 移动、复制弹窗
 * 当前主要用于LeftPanel组件
 */
export default {
  name: 'BatchRankOrCopyDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 大纲列数据
    outlineData: {
      type: Array,
      default: () => []
    },
    // 操作类型
    operationType: {
      type: String,
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['move', 'copy'].includes(value)
      }
    },
    // 已选择，正在操作的大纲项
    handleItemIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moveType: 'AFTER',
      frequency: 1, // 复制次数
      moveTypeMap: [
        { value: 'BEFORE', label: '之前' },
        { value: 'AFTER', label: '之后' }
      ],
      symbolFormItemId: ''
    }
  },
  computed: {
    operationTypeText() {
      return this.operationType === 'move' ? '移动' : '复制'
    },
    // 选项列表
    cascaderOptions() {
      const options = []
      for (let i = 0; i < this.outlineData.length; i++) {
        const el = this.outlineData[i]
        const fOption = {
          value: el.formItemGroupId, // 父节点使用 formItemGroupId
          label: el.formItemGroupName,
          children: []
        }
        el.groupItems.forEach((el2) => {
          // 操作为移动时，过滤掉已选择，正在操作的大纲项
          if (!(this.operationType === 'move' && this.handleItemIds.includes(el2.id))) {
            fOption.children.push({
              value: el2.id, // 子节点使用 id
              label: el2.title
            })
          }
        })
        options.push(fOption)
      }
      return options
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    resetForm() {
      this.symbolFormItemId = ''
      this.frequency = 1
      this.moveType = 'AFTER'
    },
    // 题目大纲 移动或复制题目
    async batchEditSelectItems() {
      const { handleItemIds, symbolFormItemId, operationType, moveType, frequency } = this
      if (!symbolFormItemId) {
        this.$message.error('请先选择题目')
        return
      }
      const api = operationType === 'move' ? saveOutlineMove : copyOutlineProject
      const params = {
        handleItemIds,
        symbolFormItemId: symbolFormItemId[1],
        formItemGroupId: symbolFormItemId[0],
        moveType,
        frequency
      }
      try {
        await api(params)
        // 把参数返回
        this.$emit('confirm', params)
      } catch (error) {
        console.error('操作失败', error)
      } finally {
        this.handleClose()
      }
    },
    validateInput(value) {
      let intValue = parseInt(value, 11)

      // 确保是整数，且在 1-9 之间
      if (!Number.isInteger(intValue) || intValue < 1 || intValue > 10) {
        this.frequency = ''
      } else {
        this.frequency = intValue
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
